/* Turns the vendor paginated list into a one page per click loader by detaching
   its infinite-scroll sentinel and re-attaching it on click, which replays the
   component's own load, prefetch, ratio pass and history entry. */
(function () {
  'use strict';

  const CARD = '[ref="cards[]"]';
  const LIST = 'results-list[data-bq-load-more]';
  const READY = 'bq-load-more-on';
  const STUCK_AFTER = 10000;

  function sentinelsOf(list) {
    const refs = list.refs || {};
    return [refs.viewMoreNext, refs.viewMorePrevious].filter(Boolean);
  }

  function cardsOf(grid) {
    return grid.querySelectorAll(':scope > ' + CARD);
  }

  // Same test the component runs before fetching: the last card names its page.
  function hasNext(list) {
    const grid = list.querySelector('[ref="grid"]');
    if (!grid) return false;
    const cards = cardsOf(grid);
    const last = cards[cards.length - 1];
    return Boolean(last) && Number(last.dataset.page) < Number(grid.dataset.lastPage);
  }

  // Idempotent: a filter update rebuilds the list and re-observes the sentinels,
  // so this runs more than once per page.
  function disarm(list) {
    const observer = list.infinityScrollObserver;
    const sentinels = sentinelsOf(list);
    if (!observer || !sentinels.length) return false;
    sentinels.forEach(function (sentinel) {
      observer.unobserve(sentinel);
    });
    return true;
  }

  function loadNext(button) {
    const list = button.closest(LIST);
    if (!list || button.getAttribute('aria-busy') === 'true') return;

    const grid = list.querySelector('[ref="grid"]');
    const observer = list.infinityScrollObserver;
    const sentinel = (list.refs || {}).viewMoreNext;
    if (!grid || !observer || !sentinel || !hasNext(list)) return;

    const before = cardsOf(grid).length;
    button.setAttribute('aria-busy', 'true');

    let watcher = null;
    let timer = 0;

    const settle = function (target) {
      if (watcher) watcher.disconnect();
      clearTimeout(timer);
      observer.unobserve(sentinel);
      button.removeAttribute('aria-busy');
      button.hidden = !hasNext(list);
      if (!target) return;
      target.tabIndex = -1;
      target.focus({ preventScroll: true });
    };

    watcher = new MutationObserver(function () {
      const cards = cardsOf(grid);
      if (cards.length <= before) return;
      settle(cards[before]);
    });
    watcher.observe(grid, { childList: true });

    // The component swallows a failed page fetch, so release the button rather
    // than leave it busy for the rest of the visit.
    timer = setTimeout(function () {
      settle(null);
    }, STUCK_AFTER);

    observer.observe(sentinel);
  }

  function wire(list) {
    if (!disarm(list)) return;
    document.documentElement.classList.add(READY);

    if (list.dataset.bqLoadMoreInit) return;
    list.dataset.bqLoadMoreInit = '1';

    // A filter update changing the page count makes the component re-observe its
    // sentinels; take them back once its own handler has run.
    new MutationObserver(function () {
      setTimeout(function () {
        disarm(list);
      }, 0);
    }).observe(list, { subtree: true, attributes: true, attributeFilter: ['data-last-page'] });
  }

  function init() {
    document.querySelectorAll(LIST).forEach(wire);
  }

  // Delegated: a filter update re-renders the button from the server.
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('[data-bq-load-more-btn]');
    if (button) loadNext(button);
  });

  init();
  // Insurance for the day the component module lands after this one.
  window.addEventListener('load', init, { once: true });
  document.addEventListener('shopify:section:load', init);
})();
